import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useAppLoading } from '@/stores/app/loading';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { signupGetFirstNameEmailAndCompany } from '@/api/signup';

export const useWizard = defineStore('wizard', () => {
  const { setLoading } = useAppLoading();
  const snackbar = useAppSnackbar();

  const email = ref('');
  const daysSinceJoining = ref('');
  const companyName = ref('');
  const accountExecutiveEmail = ref('');
  const accountExecutiveName = ref('');
  const firstName = ref('');
  const flash = ref({
    message: '',
    status: '',
    template: '',
    borderRadius: '0px 12px 0px 0px',
    templateEmail: '',
    templateEmailSubject: 'hello@datapeople.io',
  });

  // actions
  const updateFlash = ({
    message = '',
    status = 'error',
    template = '',
    borderRadius = '0px 12px 0px 0px',
    templateEmail = '',
    templateEmailSubject = 'hello@datapeople.io',
  }) => {
    if (status === 'success' && message) {
      snackbar.addSuccessSnackbar({ text: message });
    } else if (message) {
      snackbar.addErrorSnackbar({ text: message });
    }

    // TODO: remove wizard flash message
    flash.value = {
      message,
      status,
      template,
      borderRadius,
      templateEmail,
      templateEmailSubject,
    };
  };

  const resetFlash = () => {
    flash.value = {
      message: '',
      status: '',
      template: '',
      borderRadius: '0px 12px 0px 0px',
    };
  };

  const setAccountData = (userData) => {
    email.value = userData.email;
    daysSinceJoining.value = userData.daysSinceJoining;
    companyName.value = userData.companyName;
    accountExecutiveEmail.value = userData.accountExecutiveEmail;
    accountExecutiveName.value = userData.accountExecutiveName;
    firstName.value = userData.firstName;
  };

  const getFirstNameEmailAndCompany = async () => {
    setLoading({ pageLoading: true });
    try {
      const data = await signupGetFirstNameEmailAndCompany();
      setAccountData(data);
    } catch (e) {
      updateFlash({ message: e.message });
      throw e;
    } finally {
      setLoading({ pageLoading: false });
    }
  };

  return {
    // state
    email,
    flash,
    firstName,
    companyName,
    accountExecutiveEmail,
    accountExecutiveName,
    daysSinceJoining,

    // actions
    resetFlash,
    updateFlash,
    getFirstNameEmailAndCompany,
  };
});
